class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('cart-drawer-open');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    this.enableOptionalShippingSelectors();
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('cart-drawer-open');
  }

  enableOptionalShippingSelectors() {
    const form = document.getElementById('CartDrawer-Form');
    if (!form) return;

    form.setAttribute('novalidate', 'novalidate');

    const optionalSelects = form.querySelectorAll('select[required]');
    optionalSelects.forEach((select) => {
      select.removeAttribute('required');
    });

     this.applySelectyDefaults(form);
  }

  applySelectyDefaults(form) {
    const regionSelect = form.querySelector('#fields-select__region-drawer');
    if (!regionSelect) return;

    let attempts = 0;
    const maxAttempts = 20;

    const trySetRegion = () => {
      const options = Array.from(regionSelect.options || []);

      if (!options.length) {
        if (attempts < maxAttempts) {
          attempts += 1;
          setTimeout(trySetRegion, 150);
        }
        return;
      }

      const targetOption = options.find((option) => {
        const text = option.textContent || '';
        return text.toLowerCase().includes('metropolitana');
      }) || options[0];

      if (targetOption) {
        regionSelect.value = targetOption.value;
        regionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const regionWrapper = regionSelect.closest('.selector_form_container-drawer')
        || regionSelect.closest('.selector_container-drawer')
        || regionSelect.parentElement;

      if (regionWrapper) {
        regionWrapper.classList.add('cart-drawer__selecty-region-hidden');
      } else {
        regionSelect.style.display = 'none';
      }

      const regionLabel = form.querySelector('label[for="fields-select__region-drawer"]');
      if (regionLabel) {
        regionLabel.style.display = 'none';
      }
      regionSelect.setAttribute('data-region-hidden', 'true');
      regionSelect.style.display = 'none';
      const directContainer = regionSelect.closest('div');
      if (directContainer) {
        directContainer.style.display = 'none';
      }
    };

    trySetRegion();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.enableOptionalShippingSelectors();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
